import { doc, getDoc, updateDoc } from 'firebase/firestore';

import { db } from '../../firebase';

const LEGACY_CANCELED_STATUSES = new Set(['canceled', 'cancelled']);

export const normalizeStoredSubscriptionStatus = async (userId, nextStatus = 'expiring') => {
  if (!userId) {
    return false;
  }

  const summaryRef = doc(db, 'premiumSubscribers', userId);
  const summarySnapshot = await getDoc(summaryRef);

  if (!summarySnapshot.exists()) {
    return false;
  }

  const currentStatus = String(summarySnapshot.data()?.subscriptionStatus || '').trim().toLowerCase();

  if (!LEGACY_CANCELED_STATUSES.has(currentStatus)) {
    return false;
  }

  await updateDoc(summaryRef, {
    subscriptionStatus: nextStatus,
  });

  return true;
};
